import b from 'b_';
import cx from 'classnames';
import React from 'react';

import { Button, ButtonProps } from '../../button/button';
import { SimpleText } from '../../simple-text/simple-text';

import './lesson-banner-view__button.scss';

interface Props extends ButtonProps {
    textId: string;
    mix?: string;
}

export const LessonBannerViewButton = React.memo(({ textId, mix, ...props }: Props) => {
    return (
        <>
            <Button className={cx(b('lesson-banner-view', 'button', { mobile: true }), mix)} {...props}>
                <SimpleText id={textId} />
            </Button>
            <Button
                className={cx(b('lesson-banner-view', 'button', { desktop: true }), mix)}
                {...props}
                size={Button.SIZE.L}
            >
                <SimpleText id={textId} />
            </Button>
        </>
    );
});
